import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import emailTemplateKeys from '@/api/queries/emailTemplates/keyFactor';
import { graphql } from '@/gql';
import { GetEmailTemplatesInput, GetEmailTemplatesQuery } from '@/gql/graphql';

const GET_EMAIL_TEMPLATES = graphql(`
  query GetEmailTemplates($input: GetEmailTemplatesInput!) {
    emailTemplates(input: $input) {
      id
      name
      type
      template
      preview
    }
  }
`);

const useGetEmailTemplates = (
  input: GetEmailTemplatesInput,
  options?: UseQueryOptions<GetEmailTemplatesQuery>
) => {
  return useQuery({
    queryKey: emailTemplateKeys.emailTemplates(input),
    queryFn: () => {
      return gqlClient.request(GET_EMAIL_TEMPLATES, { input });
    },
    ...options,
  });
};

export default useGetEmailTemplates;
